export function clearUserSettings({ commit }){
    commit('CLEAR_USER_SETTINGS');
}